import request from '@/utils/request'
// 投票活动排行榜
export function queryVoteRankList(params) {
	return request({
		url: 'rest/activity/queryVoteRankList',
		method: 'post',
		params
	})
}
// 投票活动详情
export function queryActivityDetail(params) {
	return request({
		url: 'rest/activity/queryActivityDetail',
		method: 'post',
		params
	})
};
// 免费投票
export function freeVote(params) {
	return request({
		url: 'rest/activity/freeVote',
		method: 'post',
		params
	})
};
// 用精灵币购买礼物投票
export function payVote(params) {
	return request({
		url: 'rest/activity/payVote',
		method: 'post',
		params
	})
};
// 查询指定用户参与活动详情
export function queryUserJoinDetail(params) {
	return request({
		url: 'rest/activity/queryUserJoinDetail',
		method: 'post',
		params
	})
};
// 获取指定参与者的投票记录
export function queryVoteRecord(params) {
	return request({
		url: 'rest/activity/queryVoteRecord',
		method: 'post',
		params
	})
};
// 获取分享海报
export function getShareInfoImg(params) {
	return request({
		url: 'rest/activity/getShareInfoImg',
		method: 'post',
		params
	})
};
// 更换分享照片
export function updateShareImg(params) {
	return request({
		url: 'rest/activity/updateShareImg',
		method: 'post',
		params
	})
};
// 获取手机号
export function queryUserPhone(params) {
	return request({
		url: 'rest/mgr/queryUserPhone',
		method: 'post',
		params
	})
};
// 获取短信验证码
export function sendSmsCode(params) {
	return request({
		url: 'rest/sms/sendSmsCode',
		method: 'post',
		params
	})
};
// 验证手机验证码
export function verifyPhone(params) {
	return request({
		url: 'rest/sms/verifyPhone',
		method: 'post',
		params
	})
};
// 获取openid
export function getUserInfo(params) {
	return request({
		url: 'sys/wechatHandle/getUserInfo',
		method: 'post',
		params
	})
};
// 通过微信公众号openId登录 --第一次需要绑定手机号码 ，后续直接返回登录token信息
export function loginByMpOpenId(params) {
	return request({
		url: 'rest/sms/loginByMpOpenId',
		method: 'post',
		params
	})
};
// 公众号第一次绑定手机
export function mpBindingPhone(params) {
	return request({
		url: 'rest/sms/mpBindingPhone',
		method: 'post',
		params
	})
};
// 判断是否关注公众号
export function querySubscribeStatus(params) {
	return request({
		url: '/sys/wechatHandle/querySubscribeStatus',
		method: 'post',
		params
	})
};
// 获取js-api配置信息
export function getWxConfig(params) {
	return request({
		url: '/sys/wechatHandle/getWxConfig',
		method: 'post',
		params
	})
};
// 微信支付购买礼物
export function wxPaymentVoteGift(params) {
	return request({
		url: '/api/wxpay/wxPaymentVoteGift',
		method: 'post',
		params
	})
};
// 
export function addActivityClickNum(params) {
	return request({
		url: '/rest/index/addActivityClickNum',
		method: 'post',
		params
	})
};